import React,{useState,useEffect} from 'react';
import Burger from './burger';
import logo from '../../assets/images/logo.png';
import Tlogo from '../../assets/images/t-logo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faMobile } from '@fortawesome/free-solid-svg-icons';
import Aos from 'aos';
import 'aos/dist/aos.css';



const Nav = ({scrollToPage})=>{

   useEffect(()=>{
      Aos.init({ duration:3000 });
   },[]);

   const [navbar,setnavbar]=useState(false);

   const Scrollings = ()=>{
      if(window.scrollY >= 55){
           setnavbar(true);
      }else{
         setnavbar(false);
      }
   }

   window.addEventListener('scroll',Scrollings);

    return(
       <div className={navbar ? 'Active' : 'Nav' }>
            <div  className="logo">
           {navbar? <img src={logo} width="70px" height="40px" alt="logo" />: <img src={Tlogo} width="120px" height="70px" alt="logo" />}
            </div>
            <div>
            <Burger scrollToPage={scrollToPage}/>
            </div>
            {/* <div data-aos="fade-down" className="Number" >
            <FontAwesomeIcon icon={faMobile}/> &nbsp; 9840121115
            </div> */}
       </div>
    );
}

export default Nav;